import { useTranslation } from 'react-i18next';

import { ReactComponent as Icon } from '../../assets/icons/chargingIcon.svg';

export default function () {
  const { t } = useTranslation('translation');

  return <Icon className="MuiSvgIcon-root" alt="search-charging-icon" aria-label={t('Ladevorgang')} />;
}
